import { ACTION_AUTHEN_VERIFY_OTP, ACTION_AUTHEN_VERIFY_OTP_ERROR, ACTION_AUTHEN_VERIFY_OTP_SUCCESS, verifyToken } from "."
import * as api from "../../../api"

export const verifyOTPRequest = (hash, otp, appInfo, url) => ({
    type: ACTION_AUTHEN_VERIFY_OTP,
    payload: {
        hash, otp, appInfo, url
    }
})

export const verifyOTPSuccess = token => ({
    type: ACTION_AUTHEN_VERIFY_OTP_SUCCESS,
    payload: { access_token: token }
})

export const verifyOTPError = msg => ({
    type: ACTION_AUTHEN_VERIFY_OTP_ERROR,
    payload: { msg }
})

export const verifyOTP = (hash, otp, appInfo, url) => {
    return dispatch => {
        dispatch(verifyOTPRequest(hash, otp, appInfo, url))
        api.verifyOTP(hash, otp, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(verifyOTPError("error"));
                    return
                }
                console.log(data)
                dispatch(verifyOTPSuccess({token: data.token, app: appInfo}));
                dispatch(verifyToken(data.token, appInfo, url))
            }).catch((err) => {

                console.log(err)

                dispatch(verifyOTPError("system error"))
            });
    }
}